if(!customElements.get("pdp-modal")) {
  customElements.define("pdp-modal", class PDPModal extends HTMLElement {
    constructor() {
      super();

      this.sizechartWrapper = this.querySelector(`.content-wrapper[data-content-id="size-chart"]`);
      this.chartTriggers = this.closest(".main-product__container").querySelectorAll(".product__info-wrapper .pdp-modal--btn");

      this.chartTriggers.forEach((trig) => {
        trig.addEventListener("click", this.renderModal.bind(this, trig));
      });

      this.init();
    }

    async init() {
      const modalOverlay = this.querySelector(".pdp-modal__overlay");
      const closeBtn = this.querySelector("#closeModal");
      const continueBtn = this.querySelector("#continueBtn");
      ([modalOverlay, closeBtn, continueBtn]).forEach((elm) => {
        elm.addEventListener("click", this.closeModal.bind(this));
      });

      if(this.sizechartWrapper) {
        // populate the size chart content
        const htmlStr = await fetch("/pages/size-chart").then(response => response.text());
        const sizechartDiv = document.createElement("div");
        sizechartDiv.innerHTML = htmlStr;

        const sizechart = sizechartDiv.querySelector(".main-page");
        if(sizechart) this.sizechartWrapper.innerHTML = sizechart.innerHTML;
      }
    }

    openModal() {
      this.classList.add("modal--triggered");
    }
    closeModal() {
      this.classList.remove("modal--triggered");
    }
    renderModal(modalBtn) {
      const btnId = modalBtn.dataset.buttonId;
      console.log("button id", btnId);
      const content = this.querySelector(`.content-wrapper[data-content-id=${btnId}]`);
      const activeContent = this.querySelector(".content-wrapper.active-content");

      if(activeContent) {
        activeContent.classList.remove("active-content");
      }
      if(content) {
        if(activeContent && activeContent !== content) {
          activeContent.classList.remove("active-content");
        }
        content.classList.add("active-content");
      }

      this.openModal();
    }
  });
}
